export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 6.1391095b.pdf";